/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Occorrenza } from './occorrenza';
import { ErroreClientProblemaDTO } from './errore-client-problema-dto';


export interface Problema { 
    problema?: ErroreClientProblemaDTO;
    occorrenze?: Array<Occorrenza>;
}

